import styled from "styled-components"

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  div {
    padding-bottom: 0;

    input {
      padding-left: 2.8rem;
    }
  }
`

export const Icon = styled.div`
  width: 2.2rem;
  height: 2.2rem;
  margin-right: 2rem;
`
